import {Map} from 'maplibre-gl'

const cords = [22.00327615481416, 50.03894453916175];

// Simple mobile/low-power device detection.
// Combines a coarse pointer (touch) check with a viewport width check,
// which is more reliable than parsing navigator.userAgent.
// const isMobile = window.matchMedia('(max-width: 768px), (pointer: coarse)').matches ||
//     navigator.hardwareConcurrency <= 4 ||
//     navigator.deviceMemory <= 4;

const isMobile = window.matchMedia('(max-width: 768px), (pointer: coarse)').matches

let map;

function initMap() {
    if (map) return; // guard against double-init

    map = new Map({
        container: 'map',
        style: isMobile ? 'https://tiles.openfreemap.org/styles/bright' : 'https://tiles.openfreemap.org/styles/liberty',
        center: cords,
        zoom: 18,
        pitch: isMobile ? 0 : 30, // no tilt on mobile, avoids rendering 3D buildings at an angle
        rollEnabled: false,
        attributionControl: false,
        scrollZoom: false,
        dragPan: false
    });

    function rotateCamera(timestamp) {
        if (isMobile) return;
        // clamp the rotation between 0 -360 degrees
        // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
        map.rotateTo((timestamp / 500) % 360, {duration: 0});
        // Request the next frame of the animation.
        requestAnimationFrame(rotateCamera);
    }

    const size = 200;

    // implementation of StyleImageInterface to draw a pulsing dot icon on the map
    // Search for StyleImageInterface in https://maplibre.org/maplibre-gl-js/docs/API/
    const pulsingDot = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),

        // get rendering context for the map canvas when layer is added to the map
        onAdd() {
            const canvas = document.createElement('canvas');
            canvas.width = this.width;
            canvas.height = this.height;
            this.context = canvas.getContext('2d');
        },

        // called once before every frame where the icon will be used
        render() {
            const duration = 1500;
            const t = (performance.now() % duration) / duration;

            const radius = (size / 2) * 0.3;
            const outerRadius = (size / 2) * 0.7 * t + radius;
            const context = this.context;

            // draw outer circle
            context.clearRect(0, 0, this.width, this.height);
            context.beginPath();
            context.arc(
                this.width / 2,
                this.height / 2,
                outerRadius,
                0,
                Math.PI * 2
            );
            context.fillStyle = `rgba(236, 90, 0,${1 - t})`;
            context.fill();

            // draw inner circle
            context.beginPath();
            context.arc(
                this.width / 2,
                this.height / 2,
                radius,
                0,
                Math.PI * 2
            );
            context.fillStyle = 'rgba(236, 90, 0, 1)';
            context.strokeStyle = 'white';
            context.lineWidth = 2 + 4 * (1 - t);
            context.fill();
            context.stroke();

            // update this image's data with data from the canvas
            this.data = context.getImageData(
                0,
                0,
                this.width,
                this.height
            ).data;

            // continuously repaint the map, resulting in the smooth animation of the dot
            map.triggerRepaint();

            // return `true` to let the map know that the image was updated
            return true;
        }
    };

    map.on('load', () => {
        rotateCamera(0);
        map.addImage('pulsing-dot', pulsingDot, {pixelRatio: 2});
        map.addSource('points', {
            'type': 'geojson',
            'data': {
                'type': 'FeatureCollection',
                'features': [
                    {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',
                            'coordinates': cords
                        }
                    }
                ]
            }
        });
        map.addLayer({
            'id': 'points',
            'type': 'symbol',
            'source': 'points',
            'layout': {
                'icon-image': 'pulsing-dot'
            }
        });
    });
}

// --- Lazy init trigger ---
window.addEventListener('load', () => {
    const container = document.getElementById('map');

    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    initMap();
                    observer.disconnect(); // only need to init once
                }
            }
        },
        {
            root: null,
            rootMargin: '300px', // start loading 300px before it enters the viewport
            threshold: 0
        }
    );

    observer.observe(container);
});